import React from 'react';
import { CircularProgress } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { RESOURCE_STATUS } from '../common/constants';

export const TitleIcon = ({ status }) => {
  if (status === RESOURCE_STATUS.ERROR) {
    return <FontAwesomeIcon icon={faExclamationCircle} className="resourceIcon errorText" />;
  }

  if (status === RESOURCE_STATUS.IN_PROGRESS) {
    return <CircularProgress size={12} thickness={3} className="inProgressSpinner" />;
  }

  return null;
};
